export default __webpack_public_path__ + "static/media/paper_plane_in_circle.fc3dc873.png";